import { SeoController } from '@application/components';
import { useRouter } from '@application/utils';
import { CountryCode } from '@gql/graphql';
import { ImpressumPage } from '@presentation/pages';
import type { FC } from 'react';
import { Navigate } from 'react-router';

export const ImpressumPageController: FC = () => {
  const { translate, countryCode, translatedRoute } = useRouter();

  // TODO: change this to useNavigate hook within a useEffect hook
  if (countryCode !== CountryCode.DE) {
    return <Navigate to={translatedRoute('terms')} />;
  }

  return (
    <>
      <SeoController
        title={translate('impressum.seo.title')}
        description={translate('impressum.seo.description')}
      />
      <ImpressumPage />
    </>
  );
};
